// extracted by mini-css-extract-plugin
export default {"meduaUpload":"QuestionThumbnail_meduaUpload__dvee+"};